import React, { useState, useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import FeedAlgoForm from './FeedAlgoForm';
import FeedAlgoTest from './FeedAlgoTest';
import { useGlobal } from '../contexts/GlobalContext';

function FeedAlgoEditorColumn({ editingFeed, onSaved, onClearEdit }) {
  const { mergeCurrentContext } = useGlobal();
  const [testState, setTestState] = useState(null);

  useEffect(() => {
    mergeCurrentContext({
      feedEditorState: testState ? { feedType: testState.feedType, feedInputs: testState.feedInputs } : undefined,
    });
    return () => mergeCurrentContext({ feedEditorState: undefined });
  }, [testState, mergeCurrentContext]);
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, height: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1,
          overflow: 'hidden',
          flex: 1,
          minHeight: 0,
        }}
      >
        <Box sx={{ p: 1.5, borderBottom: 1, borderColor: 'divider', display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="subtitle1" fontWeight="medium">
            {editingFeed?.algo_id ? 'Edit feed algo' : 'Create feed algo'}
          </Typography>
          {editingFeed && (
            <Button size="small" startIcon={<AddIcon />} onClick={onClearEdit}>
              New feed algo
            </Button>
          )}
        </Box>
        <FeedAlgoForm
            key={editingFeed?.algo_id ?? 'new'}
            feed={editingFeed}
            onSaved={onSaved}
            onClear={onClearEdit}
            onTestStateChange={setTestState}
        />
      </Box>
      <FeedAlgoTest
        title="Test your feed algorithm"
        algorithm={testState?.algorithm ?? ''}
        sdkVersion={testState?.sdkVersion ?? 'V1'}
        feedType={testState?.feedType ?? 'algorithm'}
        feedInputs={testState?.feedInputs ?? 'user_id'}
        signature={testState?.signature ?? ''}
        validateInProgress={testState?.validateInProgress ?? false}
      />
    </Box>
  );
}

export default FeedAlgoEditorColumn;
